// extracted by mini-css-extract-plugin
export default {"BtnDownload":"vacationDownload_BtnDownload__WdJK9"};